import { Component, Input, OnInit, OnDestroy, Inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { FileViewExplorerComponent } from "src/app/file-view-explorer/file-view-explorer.component";
import { CommonService } from "src/app/services/common.service";
import { TabChangeService } from "src/app/services/tab-change.service";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "app-casehistory",
  templateUrl: "./casehistory.component.html",
  styleUrls: ["./casehistory.component.scss"],
})
export class CasehistoryComponent implements OnInit, OnDestroy {
  //@Input() casehistory = [];
  PatientHistory: any[] = [];
  deploymentKey:string='';
  islabadmin:boolean = false;
  
  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'case 360 prime';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  
  constructor(
    private service: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    @Inject('caseData') public casehistory: any,
    private tabChangeService: TabChangeService
  ) {}
  ngOnInit() {
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    
    this.getCaseHistory();
  }
  
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }
  async getCaseHistory() {
    this.islabadmin=this.casehistory['islabadmin'];
    if (this.casehistory.patientHistory.length > 0) {
      this.PatientHistory = [];
      this.deploymentKey=this.casehistory.deployment;
      // Step 1: Collect all data objects and all PatientHistory arrays
      let allDataObjects = [];
      let combinedPatientHistory = [];
      
      for (let i = 0; i < this.casehistory.patientHistory.length; i++) {
        let obj = {
          CaseGuid: this.casehistory.patientHistory[i].CaseGuid,
          DeploymentKey: this.deploymentKey,
        };
        this.ngxUiLoaderService.start();
        let data=await this.service.postapi('api/Case360/GetCaseXML',obj);
        
        // Collect PatientHistory from each data object and combine into one array
        let patientHistoryList = data['Case'] && data['Case']['PatientHistoryDetails'] && data['Case']['PatientHistoryDetails']['PatientHistory'];
        if(patientHistoryList && Array.isArray(patientHistoryList) && patientHistoryList.length > 0) {
          combinedPatientHistory = combinedPatientHistory.concat(patientHistoryList);
        }
        
        // Store the data object for later processing
        allDataObjects.push(data);
        this.ngxUiLoaderService.stop();
      }
      
      // Step 2: Loop through combined PatientHistory array and update each data object
      for (let j = 0; j < allDataObjects.length; j++) {
        let data = allDataObjects[j];
        let currentCaseGuid = data['Case']['CaseGUID'] || data['Case']['CaseGuid'];
        let currentAccession = data['Case']['AccessionNumber'];
        
        // Find matching entry in combined PatientHistory array
        let patienthistoryobj = combinedPatientHistory.find(x => 
          (x.CaseGuid && currentCaseGuid && x.CaseGuid.toLowerCase() === currentCaseGuid.toLowerCase()) ||
          (x.Accession && currentAccession && x.Accession === currentAccession)
        );
        
        if(patienthistoryobj != undefined) {
          data['Case']['SignOutDate'] = patienthistoryobj['SignOutDate'];
          data['Case']['RequisitionNumber'] = patienthistoryobj['RequisitionNumber'];
          if(patienthistoryobj['LastDistributionStatus']) {
            data['Case']['LastDistributionStatus'] = patienthistoryobj['LastDistributionStatus'];
          }
        }
        
        this.PatientHistory.push(data);
      }
      console.log(this.PatientHistory);
      if(this.PatientHistory.length>0){
        this.service.auditsave("View","","Viewed patient history details","case",
        this.casehistory["CaseGuid"],"Patient history tab ,deployment key :-" + this.deploymentKey
      );
    }
    } else {
      this.PatientHistory = [];
        this.toastr.warning(
          "No Patient History Found",
          "",
          {
            positionClass: "toast-bottom-right",
            timeOut: 4000,
          }
        );
    }
  }

  viewCase(item: object) {
    let obj = {
      ...this.service.CaseDataDetails,
      casedata: JSON.stringify(item),
    };
    this.service.updateCaseXMLToComponent(JSON.stringify(obj));
  }

  showRequReport(caseData: any) {
    if(caseData.Attachments==null){
      this.toastr.warning("No Requisition Report Found", "Alert", {
        positionClass: "toast-bottom-right",
        timeOut: 2000,
      });
    }
    else if (typeof caseData.Attachments.File === "object") {
      this.viewCaseFile(caseData.Attachments.File, caseData);
    } else if (Array.isArray(caseData.Attachments.File)) {
      let datas = caseData.Attachments.File.filter(
        (va) => va.Category === "Requisition"
      );
      if (datas.length > 0) {
        this.viewCaseFile(datas[datas.length - 1], caseData);
      }
    }
  }

  showFinalReport(report: any, caseData: any) {
    if (typeof report === "object") {
      this.viewCaseFile(report.File, caseData);
    } else if (Array.isArray(report)) {
      // for (let i = 0; i < report.length; i++) {
      this.viewCaseFile(report[report.length - 1].File, caseData);
      // }
    }
  }

  viewCaseFile(report, caseData) {
    let location;
    if (caseData["ServiceProvider"].length > 0) {
      location = caseData["ServiceProvider"].find(
        (value) => value.Location.AccountType == "Laboratory"
      );
      if (location !== undefined) {
        location = location.Location;
      }
    } else {
      location = caseData["ServiceProvider"].Location;
    }

    let obj = {
      RequestID: report.PresentationData,
      Type: report.Category,
      RequestGUID: report.FileGUID,
      LabOrgGUID: location.OrganizationGUID,
      CaseGUID: caseData["CaseGUID"],
      DeploymentsKey: this.deploymentKey == undefined ? '' : this.deploymentKey,
    };
    this.ngxUiLoaderService.start();
    this.service.viewCases360DXReport(obj).subscribe(
      (data) => {
        this.ngxUiLoaderService.stop();
        if (
          data.StatusMessage !== null &&
          data.StatusMessage.toLowerCase() !== "failed"
        ) {
          if (data["FileContent"] !== null) {
            "data:application/pdf;base64," + data["FileContent"];
            let namemodal = {
              name: report.ReportName,
              fullfile: data["FileContent"],
            };
            this.service.auditsave(
              "View",
              "",
              "Viewed case360 dx report :-" + report.ReportName,
              "case",
              caseData["CaseGUID"],
              "Patient history tab ,deployment key :-" + this.deploymentKey
            );
            const modalRef = this.modalService.open(FileViewExplorerComponent, {
              windowClass: "myCustomModalViewfilecase360",
              backdrop: "static",
              keyboard: false,
            });
            modalRef.componentInstance.fileData = namemodal;
            this.currentModalRefs.push(modalRef);
            
            modalRef.result.then(() => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            }, (reason) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            });
            
            // Add data attribute to identify the modal and backdrop
            setTimeout(() => {
              const modalElement = document.querySelector('.modal.show') as HTMLElement;
              if (modalElement) {
                modalElement.setAttribute('data-case360-modal', 'true');
              }
              const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
              if (backdrop) {
                backdrop.setAttribute('data-case360-modal', 'true');
              }
            }, 100);
            
            this.modalWasOpen = true;
          } else {
            this.ngxUiLoaderService.stop();
            this.toastr.warning("Data not Found", "Alert", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            });
          }
        } else {
          this.ngxUiLoaderService.stop();
          if(data.FileContent !== null && data.FileContent !== "")
            {
            this.service.copyableToastError(data.FileContent,'Failed');
          }
          else{
          this.toastr.warning("Data not Found", "Alert", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            });
          }
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
      }
    );
  }
  
  private hideModals() {
    // Only hide if we have open modals tracked in currentModalRefs
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      const case360ModalClasses = ['myCustomModalViewfilecase360'];
      
      // Find ALL modals with case360 classes (not just the first one)
      let modalElements = document.querySelectorAll('.modal[data-case360-modal="true"]') as NodeListOf<HTMLElement>;
      
      // If not found by data attribute, find by windowClass - find ALL modals
      if (modalElements.length === 0) {
        modalElements = document.querySelectorAll('.modal.myCustomModalViewfilecase360') as NodeListOf<HTMLElement>;
      }
      
      // If still not found, find any visible modal with case360 classes
      if (modalElements.length === 0) {
        const allModals = Array.from(document.querySelectorAll('.modal')) as HTMLElement[];
        const foundModals: HTMLElement[] = [];
        for (let i = allModals.length - 1; i >= 0; i--) {
          const modal = allModals[i];
          const style = window.getComputedStyle(modal);
          // Check if modal is visible and has one of the case360 classes
          const hasCase360Class = case360ModalClasses.some(className => modal.classList.contains(className));
          if (hasCase360Class && (modal.classList.contains('show') || (style.display !== 'none' && style.display !== ''))) {
            foundModals.push(modal);
          }
        }
        modalElements = foundModals as any;
      }
      
      // Hide ALL found modals (parent and nested)
      if (modalElements.length > 0) {
        this.modalWasOpen = true;
        
        modalElements.forEach(modalElement => {
          const style = window.getComputedStyle(modalElement);
          // Only hide if it's actually visible AND we have tracked modals
          if ((modalElement.classList.contains('show') || (style.display !== 'none' && style.display !== '')) && this.currentModalRefs.length > 0) {
            // Add data attribute to identify this modal for later retrieval
            modalElement.setAttribute('data-case360-modal', 'true');
            // Hide the modal visually but keep it in DOM - use !important via setProperty
            // IMPORTANT: Keep the 'show' class to prevent Bootstrap from detecting this as dismissal
            modalElement.style.setProperty('display', 'none', 'important');
            // DO NOT remove 'show' class - this prevents Bootstrap from auto-dismissing
          }
        });
        
        // Also hide all backdrops and mark them
        const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        allBackdrops.forEach(backdrop => {
          const backdropStyle = window.getComputedStyle(backdrop);
          if (backdropStyle.display !== 'none') {
            backdrop.setAttribute('data-case360-modal', 'true');
            backdrop.style.setProperty('display', 'none', 'important');
            // DO NOT remove 'show' class from backdrop - keep structure intact
          }
        });
        
        // Also hide any nested modals (nested modal scenario)
        const nestedModalSelectors = [
          '.modal.myCustomModalClass',
          '.modal.modalConfig',
          '.modal.modalConfigJSONagent',
          '.modal.myCustomModalClassaddvarule'
        ];
        
        nestedModalSelectors.forEach(selector => {
          let nestedModals = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
          nestedModals.forEach(nestedModal => {
            const nestedStyle = window.getComputedStyle(nestedModal);
            // Only hide if it's visible and not already marked as case360-modal
            if ((nestedModal.classList.contains('show') || (nestedStyle.display !== 'none' && nestedStyle.display !== '')) && 
                !nestedModal.hasAttribute('data-case360-modal')) {
              nestedModal.setAttribute('data-case360-nested-modal', 'true');
              nestedModal.style.setProperty('display', 'none', 'important');
              // Keep 'show' class to prevent dismissal
            }
          });
        });
        
        // Also hide nested modal backdrops
        const nestedBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        nestedBackdrops.forEach(nestedBackdrop => {
          const backdropStyle = window.getComputedStyle(nestedBackdrop);
          // Hide if visible and not already marked as case360-modal
          if (backdropStyle.display !== 'none' && !nestedBackdrop.hasAttribute('data-case360-modal')) {
            nestedBackdrop.setAttribute('data-case360-nested-modal', 'true');
            nestedBackdrop.style.setProperty('display', 'none', 'important');
          }
        });
        
        // Remove modal-open class from body to prevent scroll issues
        document.body.classList.remove('modal-open');
      } else {
        // No modal found but we have tracked refs - keep modalWasOpen true if we have tracked modals
        this.modalWasOpen = this.currentModalRefs.length > 0;
      }
    } else {
      // No tracked modals - nothing to hide
      this.modalWasOpen = false;
    }
  }

  private showModals() {
    // Only show if modal was open when tab became inactive
    if (this.modalWasOpen) {
      // Use a small delay to ensure DOM is ready
      setTimeout(() => {
        const case360ModalClasses = ['myCustomModalViewfilecase360'];
        
        // Find ALL modals by data attribute (most reliable)
        let modalElements = document.querySelectorAll('.modal[data-case360-modal="true"]') as NodeListOf<HTMLElement>;
        
        // If not found by data attribute, try by windowClass - find ALL modals
        if (modalElements.length === 0) {
          modalElements = document.querySelectorAll('.modal.myCustomModalViewfilecase360') as NodeListOf<HTMLElement>;
        }
        
        // If still not found, find any modal with case360 classes (even if hidden)
        if (modalElements.length === 0) {
          const allModals = Array.from(document.querySelectorAll('.modal')) as HTMLElement[];
          const foundModals: HTMLElement[] = [];
          for (let i = allModals.length - 1; i >= 0; i--) {
            const modal = allModals[i];
            const style = window.getComputedStyle(modal);
            const hasCase360Class = case360ModalClasses.some(className => modal.classList.contains(className));
            // Find modal with case360 class that is hidden (display: none) or doesn't have show class
            if (hasCase360Class && (style.display === 'none' || !modal.classList.contains('show'))) {
              foundModals.push(modal);
              // Re-add data attribute if missing
              if (!modal.hasAttribute('data-case360-modal')) {
                modal.setAttribute('data-case360-modal', 'true');
              }
            }
          }
          modalElements = foundModals as any;
        }
        
        // Show ALL found modals (parent and nested) if we still have tracked modals
        if (modalElements.length > 0 && this.currentModalRefs && this.currentModalRefs.length > 0) {
          modalElements.forEach(modalElement => {
            const style = window.getComputedStyle(modalElement);
            // Show if it was hidden (display: none)
            if (style.display === 'none' || !modalElement.classList.contains('show')) {
              // Show the modal again - override !important by setting with !important
              modalElement.style.setProperty('display', 'block', 'important');
              // Ensure show class is present
              if (!modalElement.classList.contains('show')) {
                modalElement.classList.add('show');
              }
            }
          });
          
          // Show all backdrops that were hidden (prefer those marked with data attribute)
          let backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-case360-modal="true"]')) as HTMLElement[];
          if (backdrops.length === 0) {
            backdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
          }
          
          backdrops.forEach(backdrop => {
            const backdropStyle = window.getComputedStyle(backdrop);
            if (backdropStyle.display === 'none') {
              backdrop.style.setProperty('display', 'block', 'important');
              if (!backdrop.classList.contains('show')) {
                backdrop.classList.add('show');
              }
            }
          });
          
          // Also show nested modals if they were open (nested modal scenario)
          const nestedModalSelectors = [
            '.modal.myCustomModalClass',
            '.modal.modalConfig',
            '.modal.modalConfigJSONagent',
            '.modal.myCustomModalClassaddvarule'
          ];
          
          nestedModalSelectors.forEach(selector => {
            let nestedModals = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
            nestedModals.forEach(nestedModal => {
              const nestedStyle = window.getComputedStyle(nestedModal);
              // Show if it was hidden (display: none) - meaning it was open before
              if ((nestedStyle.display === 'none' || !nestedModal.classList.contains('show')) && 
                  !nestedModal.hasAttribute('data-case360-modal')) {
                nestedModal.style.setProperty('display', 'block', 'important');
                if (!nestedModal.classList.contains('show')) {
                  nestedModal.classList.add('show');
                }
              }
            });
          });
          
          // Also show nested modal backdrops
          let nestedBackdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-case360-nested-modal="true"]')) as HTMLElement[];
          // If no backdrops found by data attribute, find all backdrops that aren't marked as case360-modal
          if (nestedBackdrops.length === 0) {
            const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
            nestedBackdrops = allBackdrops.filter(backdrop => !backdrop.hasAttribute('data-case360-modal'));
          }
          nestedBackdrops.forEach(nestedBackdrop => {
            const backdropStyle = window.getComputedStyle(nestedBackdrop);
            if (backdropStyle.display === 'none') {
              nestedBackdrop.style.setProperty('display', 'block', 'important');
              if (!nestedBackdrop.classList.contains('show')) {
                nestedBackdrop.classList.add('show');
              }
            }
          });
          
          // Re-add modal-open class to body
          document.body.classList.add('modal-open');
          
          // Verify modals are visible after a brief moment
          setTimeout(() => {
            // Double-check we still have tracked modals (user didn't close it)
            if (this.currentModalRefs && this.currentModalRefs.length > 0) {
              modalElements.forEach(modalElement => {
                const style = window.getComputedStyle(modalElement);
                if (style.display === 'none' || !modalElement.classList.contains('show')) {
                  // If Bootstrap hid it again, force show it
                  modalElement.style.setProperty('display', 'block', 'important');
                  modalElement.classList.add('show');
                }
              });
            }
          }, 200);
        } else {
          // If modal not found or no tracked modals, reset the flag
          if (!this.currentModalRefs || this.currentModalRefs.length === 0) {
            this.modalWasOpen = false;
          }
        }
      }, 150);
    }
  }
}
